module.exports = __webpack_public_path__ + "static/img/HYNTlogo.a2c3fbc1.png";